// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hvgwl","tabsBox":"styles_tabsBox__ZzCs6","createButton":"styles_createButton__1KKFX"};